import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconDotsVerticalRounded = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }) }));
const Memo = memo(SvgIconDotsVerticalRounded);
export default Memo;
//# sourceMappingURL=IconDotsVerticalRounded.js.map